module.exports = __webpack_public_path__ + "static/media/red_stacker.5fd7e344.png";